import { lazy, ReactNode, Suspense, useLayoutEffect } from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { UiModeProvider, useUiMode } from './ui-mode/UiModeProvider';

const ClassicApp = lazy(() => import('./ClassicUiEntry'));
const NewApp = lazy(() => import('./NewUiEntry'));

// WORKAROUND: Scroll to top when the route changes
const Wrapper = ({ children }: { children: ReactNode }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return <div>{children}</div>;
};

const UiModeApp = () => {
  const { uiMode } = useUiMode();

  return <Suspense fallback={null}>{uiMode === 'classic' ? <ClassicApp /> : <NewApp />}</Suspense>;
};

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  // <React.StrictMode>
  <Router>
    <Wrapper>
      <RecoilRoot>
        <UiModeProvider>
          <UiModeApp />
        </UiModeProvider>
      </RecoilRoot>
    </Wrapper>
  </Router>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
